export enum ERangeErrorMessages {
  Max = 'Значение не может быть более 2,1 млрд',
  GteLte = 'Это значение должно быть больше значения "от"',
  GteRequired = 'Введите значение "от"',
  LteRequired = 'Введите значение "до"',
}
